import { useState } from 'react';
import { HttpStatusCode } from 'axios';
import { useCallback } from 'react';
import { useDocumentService } from 'services';
import { AttachedDocument } from 'types';

export default function useDisputeDocument(disputeNumber: string = "", download: boolean = false) {
    const documentService = useDocumentService();
    const [showError, setShowError] = useState<boolean>(false);
    const [errorIdentifier, setErrorIdentifier] = useState<string>("");

    const downloadDocument = useCallback(async ({ documentName }: AttachedDocument) => {
        const response = await documentService?.getDisputeDocument(disputeNumber, documentName);
        
        if (!response || response.status === HttpStatusCode.NotFound || response.status === HttpStatusCode.BadRequest) {
            setErrorIdentifier(disputeNumber);
            setShowError(true);
            return;
        }

        if (response.data) {
            const file = new File([response.data as Blob], documentName, { type: (response.data as Blob).type });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            if (download) {
                a.download = documentName;
            }
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }, [disputeNumber, documentService, download]);

    return Object.assign(downloadDocument, {
        showError,
        setShowError,
        errorIdentifier
    });
}